/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Min_Gap_TitleInputs */

const en_ad_template_min_gap_title = /** @type {(inputs: Ad_Template_Min_Gap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum Gap Time`)
};

const fr_ad_template_min_gap_title = /** @type {(inputs: Ad_Template_Min_Gap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée minimale d'écart`)
};

const de_ad_template_min_gap_title = /** @type {(inputs: Ad_Template_Min_Gap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestlücke`)
};

const it_ad_template_min_gap_title = /** @type {(inputs: Ad_Template_Min_Gap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo minimo di intervallo`)
};

const ru_ad_template_min_gap_title = /** @type {(inputs: Ad_Template_Min_Gap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальный интервал`)
};

const es_ad_template_min_gap_title = /** @type {(inputs: Ad_Template_Min_Gap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo mínimo de hueco`)
};

const zh_cn2_ad_template_min_gap_title = /** @type {(inputs: Ad_Template_Min_Gap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小间隔时间`)
};

const ja_ad_template_min_gap_title = /** @type {(inputs: Ad_Template_Min_Gap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小ギャップ時間`)
};

const hi_ad_template_min_gap_title = /** @type {(inputs: Ad_Template_Min_Gap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम अंतराल समय`)
};

const pt_pt2_ad_template_min_gap_title = /** @type {(inputs: Ad_Template_Min_Gap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo mínimo de intervalo`)
};

/**
* | output |
* | --- |
* | "Minimum Gap Time" |
*
* @param {Ad_Template_Min_Gap_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_min_gap_title = /** @type {((inputs?: Ad_Template_Min_Gap_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Min_Gap_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_template_min_gap_title(inputs)
	if (locale === "de") return de_ad_template_min_gap_title(inputs)
	if (locale === "it") return it_ad_template_min_gap_title(inputs)
	if (locale === "ru") return ru_ad_template_min_gap_title(inputs)
	if (locale === "es") return es_ad_template_min_gap_title(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_template_min_gap_title(inputs)
	if (locale === "ja") return ja_ad_template_min_gap_title(inputs)
	if (locale === "hi") return hi_ad_template_min_gap_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_template_min_gap_title(inputs)
	return en_ad_template_min_gap_title(inputs)
});